import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiGlobe } from 'react-icons/fi';

const languages = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'am', label: 'አማ', name: 'አማርኛ' },
  { code: 'ti', label: 'ትግ', name: 'ትግርኛ' },
];

const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const current = languages.find(l => l.code === i18n.language) || languages[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('i18nextLng', code);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <select
        value={i18n.language?.split('-')[0] || 'en'}
        onChange={e => change(e.target.value)}
        style={{
          padding: '6px 10px 6px 30px',
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: 8,
          fontSize: 13,
          fontWeight: 600,
          color: '#374151',
          cursor: 'pointer',
          appearance: 'none',
          minWidth: compact ? 70 : 110,
        }}
      >
        {languages.map(l => (
          <option key={l.code} value={l.code}>{compact ? l.label : l.name}</option>
        ))}
      </select>
      <FiGlobe style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#6b7280', pointerEvents: 'none' }} />
    </div>
  );
};

export default LanguageSwitcher;
